import Vue from 'vue'
import Vuex from 'vuex'
import decode from 'jwt-decode'
import router from '../router/index'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isDark: true,

    token: null,
    usuario: null,

    tipoUnidadesStore: null,
    dataTipoUnidadesStore: [],

    sedeStore: null,
    dataSedesStore: [],

    unidadStore: null,
    dataUnidadStore: [],

    personalStore: null,
    dataPersonalStore: [],

    bienStore: null
  },
  mutations: {
    setToken(state, token) {
      state.token = token
    },

    setUsuario(state, usuario) {
      state.usuario = usuario
    },
  },
  actions: {
    guardarToken({ commit }, token) {
      commit("setToken", token)
      commit("setUsuario", decode(token))
      localStorage.setItem("token-inventarios", token)
      router.push({ name: 'Home' })

    },

    autoLogin({ commit }) {
      let token = localStorage.getItem("token-inventarios")
      if (token) {
        commit("setToken", token)
        commit("setUsuario", decode(token))
        router.push({ name: 'Home' })

      }
    },

    salir({ commit }) {
      commit("setToken", null)
      commit("setUsuario", null)
      localStorage.removeItem("token-inventarios")
      router.push({ name: 'Login' })
    },
  },
  modules: {
  }
})
